export const PLATAFORMAS = 'plataformas';
export const PERIODOS = 'periodos';
export const VALORACIONES_UTF = 'valoracionesUTF';
export const BENEFICIADOS = 'beneficiados';
export const USUARIOS_FISCALIZACION = 'usuariosFiscalizacion';
export const UNIDADES_MEDIDA = 'unidadesMedida';
export const CANDIDATURAS = 'candidaturas';
export const SUJETOS_OBLIGADOS = 'sujetosObligados';
export const TIPO_ASOCIACIONES = 'tipoAsociaciones';
export const TIPO_BENEFICIO = 'tipoBeneficio';
export const TIPO_ACTAS = 'tipoActas';
export const HALLAZGOS = 'hallazgos';
export const TIPO_MONITOREOS = 'tipoMonitoreos';
export const ATRIBUTOS = 'atributosHallazgos';
export const PROCESOS_ELECTORALES = 'procesosElectorales';
export const TIPO_ELECCION = 'tipoEleccion';
export const PROCESOS_ESPECIFICOS = 'procesosEspecificos';
export const ESTADOS = 'estados';
export const ROLES_USUARIO = 'rolesUsuario';
export const CONFIGURACION_SISTEMA = 'configuracionSistema';
